// global variables that should be used accross the whole project
//
// how-to-use:
// import globals from './path/to/globals';
// let myBackgroundColor = globals.colors.backgroundColor; 
//
//
// this way the variable names inside globals will not interfere with the ones 
// in the files where you are importing them

import { light } from "@mui/material/styles/createPalette";

const globals = {
    apiUrl: process.env.REACT_APP_API_URL || "https://api.eacademiabg.com",
    colors: {

        lightGreen: '#67AD51',
        lightRed: '#e26965',
        lightPink: '#F6EAE9',
        lightYellow: '#F3CC5D',
        lightBlue: '#64669D',
        lightGray: '#E0E0E0',

        darkGreen: '#0F9405',
        darkRed: '#B21625',
        darkYellow: '#F0C041',
        darkBlue: '#323B60',
        gray: '#5D5D5D',

        backgroundColor: '#F2F4F4',
        textColor: '#050102',

    },
    text: {
        title: {
            fontSize: {
                xs: 40,
                sm: 80,
            },
            fontWeight: 'bold',
        },
        subtitle: {
            fontSize: {
                xs: 20,
                sm: 30,
            },
            fontWeight: 'bold',
        },
        body: {
            fontSize: 16,
        },
    }
}

export default globals;
